import React from 'react';

import { PaymentMethodFlatListWithButton } from 'components/payment-method-flat-list-with-button';
import AuthRequired from 'pages/authentication/components/auth-required';

const PaymentMethods = () => {
  return (
    <AuthRequired>
      <PaymentMethodFlatListWithButton />
    </AuthRequired>
  );
};

export default PaymentMethods;
